import React from 'react';
import PropTypes from 'prop-types';
import { ReclamationActionDetailType } from 'constants.js';
import { connect } from 'react-redux';
import { addAction } from 'store/reclamation/reclamationsActions';
import AddReponse from './AddReponse';

class AddReponseContainer extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const initialState = {
            open: false,
            text: '',
            reponseAttendue: false,
            fichiersIds: []
        };
        return initialState;
    }

    componentDidMount() {
        this.setState(this.getInitialState());
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {

        const { open } = this.props;

        if (open === false && nextProps.open === true) {
            this.setState(this.getInitialState());
        }
    }

    handleClickSave = () => {

        const { actionId, reclamationId, addAction } = this.props;
        const { text, reponseAttendue, fichiersIds } = this.state;

        let actionData = {
            code: "REPONSE",
            parentReclamationActionId: actionId,
            details: [{
                code: "REPONSE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Votre réponse :",
                position: 0,
                valeurString: text
            }],
            reponseAttendue: reponseAttendue
        };

        if (fichiersIds.length > 0) {
            actionData = { ...actionData, fichiersIds: fichiersIds };
        }

        addAction(reclamationId, actionData, actionId);



        this.setState({
            ...this.state,
            open: false
        });
    }

    handleClickAnswer = () => {

        let newState = this.getInitialState();

        newState.open = true;

        this.setState(newState);
    }

    handleClickCancel = () => {
        this.setState(this.getInitialState());
    }
       
    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };
        this.setState(newState);
    }

    handleChangeReponseAttendue = () => {

        const newState = {
            ...this.state,
            reponseAttendue: !this.state.reponseAttendue
        };

        this.setState(newState);
    }


    render() {
        const { open, text, reponseAttendue } = this.state;
        const { isAdding } = this.props;

        return (
            <AddReponse
                text={text}
                open={open}
                reponseAttendue={reponseAttendue}
                onClickSave={this.handleClickSave}
                onClickAnswer={this.handleClickAnswer}
                onClickCancel={this.handleClickCancel}
                onChange={this.handleChange}
                isAdding={isAdding}
                onChangeReponseAttendue={this.handleChangeReponseAttendue}
                
            />
        );
    }
}

AddReponseContainer.propTypes = {
    actionId: PropTypes.number.isRequired,
    reclamationId: PropTypes.number.isRequired
};




const mapStateToProps = (state, ownProps) => ({
    isAdding: state.common.addActionData.actionId === ownProps.actionId
});


const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId) => dispatch(addAction(reclamationId, actionData, actionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReponseContainer);